import { CheckIcon, CopyIcon, Flex, Typography } from '@iheartjane/reefer';
import type { IconSize } from '@iheartjane/reefer';
import { useState } from 'react';

import styles from './copyLink.module.css';

const COPIED_FEEDBACK_MS = 1000;

interface CopyLinkProps {
  /** Announces what is being copied, since the icon has no visible text */
  ariaLabel: string;

  iconSize?: IconSize;

  label: string;

  /** Copied to the clipboard on click. Nothing happens when it is empty */
  value?: string;
}

/**
 * A dashed-underline affordance that copies `value` and briefly swaps its icon
 * for a checkmark to confirm the copy.
 */
export const CopyLink = ({
  ariaLabel,
  iconSize,
  label,
  value,
}: CopyLinkProps) => {
  const [showCopied, setShowCopied] = useState(false);

  const copy = () => {
    if (!value) return;

    navigator.clipboard.writeText(value);
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), COPIED_FEEDBACK_MS);
  };

  return (
    <Flex alignItems="center" aria-label={ariaLabel} onClick={copy}>
      {showCopied ? (
        <CheckIcon altText="Copied" />
      ) : (
        <CopyIcon size={iconSize} />
      )}
      <Typography className={styles['label']} color="grays-dark" ml={8}>
        {label}
      </Typography>
    </Flex>
  );
};
